module.exports = __webpack_public_path__ + "static/media/hg659-small.1dc948e1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/hg659-small.png
 ** module id = 1302
 ** module chunks = 0
 **/